import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import GameMenu from "../components/GameMenu";
import Timer from "../components/Timer";
import Popup from "../components/Popup";
import LeaveGamePopup from "../components/LeaveGamePopup";
import GameWrapper from "../components/GameCountdown";
// import EndGameBtn from "../components/EndGameBtn";
import "../assets/css/arrowsQCM.css";

export default function ArrowsQCM() {
  const [gameStarted, setGameStarted] = useState(false);

  const location = useLocation();
  const { theme, subTheme } = location.state || {};

  const [timerIsFinished, setTimerIsFinished] = useState(false);
  const [timeElapsed, setTimeElapsed] = useState(0);
  const [leaveGamePopup, setLeaveGamePopup] = useState(false);

  const getTimerTimeRef = useRef(null);

  // Questions (à changer pour récupérer en base de données)
  const questions = [
    {
      question: "Quelle est la capitale de l'Australie ?",
      options: ["Sydney", "Melbourne", "Canberra", "Brisbane"],
      correctAnswer: "Canberra",
    },
    {
      question: "Combien font 3 x 4 ?",
      options: ["7", "12", "15", "18"],
      correctAnswer: "12",
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const [score, setScore] = useState(0);
  const [finished, setFinished] = useState(false);

  const [holdingAnswer, setHoldingAnswer] = useState(null); // réponse en cours de sélection
  const holdTimerRef = useRef(null);

  const currentQuestion = questions[currentIndex];

  // Récupérer le temps envoyé par Timer
  const sendTime = (time) => {
    setTimeElapsed(time);
  };

  const sendLeaveGame = (value) => {
    setLeaveGamePopup(value);
  };

  // Logique du jeu au choix d'une réponse
  const handleAnswerClick = (answer) => {
    if (!selectedAnswer) {
      setSelectedAnswer(answer);

      if (answer === currentQuestion.correctAnswer) {
        setScore((prev) => prev + 1);
      }

      // passer automatiquement à la question suivante après 3s
      setTimeout(() => {
        nextQuestion();
      }, 3000);
    }
  };

  const nextQuestion = () => {
    if (currentIndex + 1 < questions.length) {
      setCurrentIndex((prev) => prev + 1);
      setSelectedAnswer(null);
    } else {
      endGame();
    }
  };

  // CSS appliqué en fonction des réponses
  const getButtonClass = (answer) => {
    if (holdingAnswer === answer && !selectedAnswer) return "holding"; // en cours de validation
    if (!selectedAnswer) return "";
    if (answer === currentQuestion.correctAnswer) return "correct";
    if (answer === selectedAnswer) return "wrong";
    return "";
  };

  const endGame = () => {
    if (getTimerTimeRef.current) {
      const currentTime = getTimerTimeRef.current();
      sendTime(currentTime);
    }
    setFinished(true);
    setTimerIsFinished(true);
  };

  // Gestion des flèches avec maintien
  useEffect(() => {
    const keyMap = {
      ArrowUp: 0,
      ArrowRight: 1,
      ArrowDown: 2,
      ArrowLeft: 3,
    };

    const handleKeyDown = (e) => {
      if (finished || selectedAnswer) return;
      if (!(e.key in keyMap)) return;

      const index = keyMap[e.key];
      const answer = currentQuestion.options[index];

      if (!holdTimerRef.current) {
        setHoldingAnswer(answer);
        holdTimerRef.current = setTimeout(() => {
          handleAnswerClick(answer);
          setHoldingAnswer(null);
          holdTimerRef.current = null;
        }, 1000); // 1 seconde
      }
    };

    const handleKeyUp = () => {
      if (holdTimerRef.current) {
        clearTimeout(holdTimerRef.current);
        holdTimerRef.current = null;
        setHoldingAnswer(null);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("keyup", handleKeyUp);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("keyup", handleKeyUp);
    };
  }, [currentQuestion, selectedAnswer, finished]);

  return (
    <div className="page-container">
      <Sidebar />

      <GameWrapper onStart={() => setGameStarted(true)}>
        <div className="content-container inGame" id="arrowsQCM">
          <div className="title">
            <h4>{theme} - {subTheme}</h4>
            <div className="level-infos">
              <Timer
                timer={timerIsFinished}
                onFinish={() => endGame()}
                onSendTime={sendTime}
                onGetTime={(getTimeFn) => (getTimerTimeRef.current = getTimeFn)}
                hasLimit={true}
                limit={120} 
              />
            </div>
          </div>

            <div className="game-container launched">
              {/* {!finished ? (
                <> */}
                  {/* <div className="arrows-top"> */}
                    <div className="arrows-info">
                      <div className="arrows-length">
                        <p>
                          Question {currentIndex + 1}/{questions.length}
                        </p>
                        <div className="progress-bar">
                          <div
                            className="progress-fill"
                            style={{
                              width: `${((currentIndex + 1) / questions.length) * 100}%`,
                            }}
                          ></div>
                        </div>
                      </div>
                      <h3 className="arrows-score">
                        Score : {score}/{questions.length}
                      </h3>
                    </div>
                    <div className="arrows-QR">
                      <h2 className="arrows-question">{currentQuestion.question}</h2>
                      <h3 className="arrows-rules">Maintenez la flèche correspondante enfoncée pour valider une réponse.</h3>
                    </div>
                  {/* </div> */}
                  <div className="arrows-options">
                    {currentQuestion.options.map((answer, index) => (
                      <button
                        key={index}
                        className={`arrows-button option${index} ${getButtonClass(answer)}`}
                        disabled
                      >
                        <span>{answer}</span>
                      </button>
                    ))}
                  </div>
                {/* </>
              ) : ( */}
              {/* )} */}
            </div>
          

          {/* <EndGameBtn onClick={endGame} /> */}
        </div>
      </GameWrapper>

      <GameMenu onSendLeaveGame={sendLeaveGame} />
      <Popup
        time={timeElapsed}
        timerIsFinished={timerIsFinished}
        errorCount={questions.length - score}
      />
      <LeaveGamePopup
        popupOpen={leaveGamePopup}
        onSendLeaveGame={sendLeaveGame}
      />
    </div>
  );
}
